import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { Tooltip } from "@material-tailwind/react";
import { Typography } from "@material-tailwind/react";
const ToolTipQuestions = () => {
    return (
        <Tooltip
            placement="bottom"
            className="bg-white border border-blue-gray-50 shadow-xl shadow-black/10 px-4 py-3"
            content={
                <div className="w-80">
                    <Typography color="blue-gray" className="font-medium">Questions Description</Typography>
                    <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal opacity-80"
                    >
                        <ul className="list-inside space-y-10">
                            <li >
                                <span className="text-center py-2 px-3 cursor-pointer bg-gray-300 text-black rounded">-</span> - Unattempted Question
                            </li>
                            <li >
                                <span className="text-center py-2 px-3 cursor-pointer bg-green-300 text-white rounded">-</span> - Attempted Question
                            </li>
                            <li >
                                <span className="text-center py-2 px-3 cursor-pointer bg-yellow-500 text-black  rounded">-</span> - Marked for Review
                            </li>
                            <li >
                                <span className="text-center py-2 px-3 cursor-pointer bg-orange-500 rounded-md text-white rounded">-</span> - Marked for Review and Answered
                            </li>
                        </ul>
                    </Typography>
                </div>
            }
        >
            <div>

                <InformationCircleIcon
                    strokeWidth={2}
                    className="text-blue-gray-500 w-5 h-5 cursor-pointer inline"
                /> Info.
            </div>


        </Tooltip>
    )
}

export default ToolTipQuestions;